/**
 * Base class with common utility methods for strategies
 */
export class BaseStrategy {
    /**
     * Find the entry node(s) of a flow
     */
    findEntryNodes(flow) {
        const targetNodes = new Set(flow.edges.map((e) => e.target));
        return flow.nodes.filter((n) => !targetNodes.has(n.id)).map((n) => n.id);
    }
    /**
     * Get outgoing edges from a node
     */
    getOutgoingEdges(flow, nodeId) {
        return flow.edges.filter((e) => e.source === nodeId);
    }
    /**
     * Get incoming edges to a node
     */
    getIncomingEdges(flow, nodeId) {
        return flow.edges.filter((e) => e.target === nodeId);
    }
    /**
     * Get a node by ID
     */
    getNode(flow, nodeId) {
        return flow.nodes.find((n) => n.id === nodeId);
    }
    /**
     * Build a Home Assistant trigger from a trigger node.
     *
     * Empty values are dropped, and a device trigger's `entity_id` is written as a
     * single entity: Home Assistant validates that one with `cv.entity_id` and
     * refuses a list, so a one-entity list makes the automation unsaveable. A list
     * of several is left alone — Home Assistant's own error is better than
     * silently dropping the rest.
     */
    buildTrigger(node) {
        const trigger = { ...node.data };
        const isDeviceTrigger = trigger.trigger === 'device' || trigger.platform === 'device';
        if (isDeviceTrigger && Array.isArray(trigger.entity_id) && trigger.entity_id.length === 1) {
            trigger.entity_id = trigger.entity_id[0];
        }
        return Object.fromEntries(Object.entries(trigger).filter(([, v]) => v !== undefined && v !== '' && v !== null));
    }
}
//# sourceMappingURL=base.js.map